/* KFC Auction PDP — scale the right-column auction widget so its rendered
   height matches the image column. Watches viewport resize, image load,
   and widget DOM mutations (the Auction Today JS injects content async). */
(function () {
  'use strict';

  function fitWidget() {
    const img = document.querySelector('.kfc-auction-pdp .product__media-item img, .kfc-auction-pdp .product__media-wrapper img');
    const area = document.querySelector('.kfc-auction-pdp__widget-area');
    if (!img || !area) return;

    const targetH = img.getBoundingClientRect().height;
    if (!targetH) return;

    // Stable wrapper rendered by main-product.liquid. Falls back to the
    // first child for older renders that haven't picked up the wrapper.
    const inner = area.querySelector('.kfc-auction-pdp__widget-inner') || area.firstElementChild;
    if (!inner) return;

    // Reset before measuring natural height. Force width to 100% so the
    // widget always fills its column horizontally — without this, when the
    // widget already fits vertically (no transform needed) the inner
    // element falls back to its natural content width, which is typically
    // narrower than the column and leaves a gap on the right inside the
    // orange frame.
    inner.style.transform = '';
    inner.style.width = '100%';
    inner.style.transformOrigin = 'top left';
    area.style.height = '';

    const naturalH = inner.scrollHeight;
    if (!naturalH) return;

    // Constrain the widget column's layout height to the image height.
    // CSS transform: scale() shrinks the inner widget visually, but the
    // unscaled element still contributes its full natural height to the
    // grid row — which would make the row taller than the image and leave
    // a dead band of dark panel above the bottom orange border. Pinning
    // the area to targetH keeps the row equal to the image, so the orange
    // frame's inner padding stays visually uniform on all four sides.
    area.style.height = targetH + 'px';

    if (naturalH <= targetH) {
      // Already fits; keep at 1× scale.
      return;
    }

    const scale = Math.max(0.55, Math.min(1, targetH / naturalH));
    inner.style.transform = 'scale(' + scale + ')';
    // Compensate width so the visual content fills the column even at < 1× scale.
    inner.style.width = (100 / scale) + '%';
  }

  function schedule() {
    requestAnimationFrame(fitWidget);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);

  // The Auction Today widget renders async, so re-fit when its DOM mutates.
  const area = () => document.querySelector('.kfc-auction-pdp__widget-area');
  const startObserver = () => {
    const node = area();
    if (!node) {
      requestAnimationFrame(startObserver);
      return;
    }
    new MutationObserver(() => schedule()).observe(node, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    schedule();
  };
  startObserver();

  // ----------------------------------------------------------------------
  // Privacy: redact bidder names + emails in the "View all bids" modal.
  // The modal is rendered by the Auction Today app (tingle.js) and contains
  // a table of bid history with full customer names and email addresses.
  // We post-process it on insertion to keep only the first 3 chars of each
  // value followed by ***. Done client-side as a defence-in-depth measure;
  // the proper fix is for the app to not send PII to the storefront.
  // ----------------------------------------------------------------------
  const REDACT = (s) => {
    const t = (s || '').trim();
    return t.length > 3 ? t.slice(0, 3) + '***' : t;
  };
  const EMAIL_RE = /[^\s@]+@[^\s@]+\.[^\s@]+/;
  const NAME_HEADER_RE = /name|bidder|customer|user/i;
  const EMAIL_HEADER_RE = /e-?mail/i;

  function redactTable(table) {
    if (table.dataset.kfcRedactInit === '1') {
      // Re-scan body rows only (header columns already classified).
      redactRows(table);
      return;
    }
    table.dataset.kfcRedactInit = '1';
    const headers = Array.from(table.querySelectorAll('thead th, tr:first-child th, tr:first-child td'));
    const nameCols = [];
    const emailCols = [];
    headers.forEach((h, i) => {
      const text = (h.textContent || '').toLowerCase();
      if (EMAIL_HEADER_RE.test(text)) emailCols.push(i);
      else if (NAME_HEADER_RE.test(text)) nameCols.push(i);
    });
    table._kfcNameCols = nameCols;
    table._kfcEmailCols = emailCols;
    redactRows(table);
  }

  function redactRows(table) {
    const nameCols = table._kfcNameCols || [];
    const emailCols = table._kfcEmailCols || [];
    const rows = table.querySelectorAll('tbody tr, tr');
    rows.forEach((row) => {
      const cells = row.querySelectorAll('td');
      cells.forEach((cell, i) => {
        if (cell.dataset.kfcRedacted === '1') return;
        const original = cell.textContent;
        const inNameCol = nameCols.indexOf(i) !== -1;
        const inEmailCol = emailCols.indexOf(i) !== -1;
        const looksEmail = EMAIL_RE.test(original);
        if (inNameCol || inEmailCol || looksEmail) {
          cell.textContent = REDACT(original);
          cell.dataset.kfcRedacted = '1';
        }
      });
    });
  }

  function processModal(root) {
    if (!root) return;
    root.querySelectorAll('table').forEach(redactTable);
  }

  // Watch the whole document for the bid-history modal opening, then re-watch
  // its subtree because the app fetches bids async after the modal opens.
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches && (node.matches('.tingle-modal') || node.matches('.tingle-modal-box__content'))) {
          processModal(node);
          new MutationObserver(() => processModal(node)).observe(node, { childList: true, subtree: true });
        } else if (node.querySelector && node.querySelector('.tingle-modal-box__content')) {
          processModal(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
